import React from "react";
import wechat from "../../assets/8cm.jpg";

const QRcode = () => {
  return (
    <div className="flex w-48 h-48 space-x-4">
      <div className="flex flex-col gap-y-1 items-center">
        <img
          className="rounded-md"
          src='http://1.94.62.64:9090/myf/photos/wechat_qr.jpg'
        />
        <p className="text-sm" title="微信公众号">微信公众号</p>
      </div>
      <div className="flex flex-col gap-y-1 items-center">
        <img
          className="rounded-md"
          src='http://1.94.62.64:9090/myf/photos/tiktok_qr.jpg'
        />
        <p className="text-sm" title="墨圆方抖音">墨圆方抖音</p>
      </div>
    </div>
  );
};

export default QRcode;
